/* =====================================================
   Equation Grid Component – Version 2.1 (Modified: July 31, 2025)
   Main game board where equations are constructed
   Date Modified: 31 July 2025 | Time: Current
===================================================== */

import { memo } from 'react'
import { useGameState } from '../hooks/useGameState'
import EquationSlot from './EquationSlot'
import styles from './EquationGrid.module.css'

/**
 * Grid component displaying 6 rows of equation slots
 * Each row contains 11 slots alternating between numbers and operators
 */
function EquationGrid() {
  const { grid } = useGameState()

  return (
    <div className={styles.equationMatrix}>
      {grid.map((row, rowIndex) => (
        <EquationRow 
          key={rowIndex} 
          row={row} 
          rowIndex={rowIndex} 
        />
      ))}
    </div>
  )
}

/**
 * Individual equation row component
 * Memoized to prevent unnecessary re-renders
 */
const EquationRow = memo(function EquationRow({ row, rowIndex }) {
  return (
    <div className={styles.equationGrid} data-row={rowIndex}>
      {row.map((slot, slotIndex) => (
        <EquationSlot
          key={`${rowIndex}-${slotIndex}`}
          slot={slot}
          rowIndex={rowIndex}
          slotIndex={slotIndex}
          expectedType={slotIndex % 2 === 0 ? 'number' : 'operator'}
        />
      ))}
    </div>
  )
})

export default EquationGrid